<!--
  LINE "Home" (friends) screen preview, a faithful copy of the real dark LINE
  UI (black canvas, white text, LINE-green badges). The only theme-specific part
  is the live <app-line-menu-bg> behind the bottom tab bar.
-->
<div class="line-stage">
  <div class="phone"
       [style.--editor]="editorBg"
       [style.--fg]="fg"
       [style.--fg-dim]="fgDim"
       [style.--accent]="accent">
    <div class="screen">

      <!-- Coloured header block (Sakura: pink with white text); the body below
           stays on the white/editor background, mirroring LINE's mockup. -->
      <div class="header-block" [class.color-header]="headerBg !== 'transparent'"
           [style.background]="headerBg" [style.--header-text]="headerText">

      <!-- iOS status bar -->
      <div class="statusbar">
        <span class="time">9:41</span>
        <span class="status-right" aria-hidden="true"></span>
      </div>

      <!-- top actions: bookmark / bell / + / gear. On iOS 26 they sit in a
           translucent glass pill (owner 2026-07-29). -->
      <div class="topbar" [class.glass-actions]="ios26"
           [style.--top-pill]="topPillBg || null" [style.--top-pill-ink]="topPillInk || null">
        <div class="ti-actions">
          <svg viewBox="0 0 24 24" class="ti"><path d="M6 3h12v18l-6-4-6 4z" fill="none" stroke-width="1.7"/></svg>
          <svg viewBox="0 0 24 24" class="ti"><path d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6M9.5 21a2.5 2.5 0 0 0 5 0" fill="none" stroke-width="1.7"/></svg>
          <svg viewBox="0 0 24 24" class="ti"><path d="M12 5v14M5 12h14" fill="none" stroke-width="1.9"/></svg>
          <svg viewBox="0 0 24 24" class="ti"><circle cx="12" cy="12" r="3" fill="none" stroke-width="1.7"/><path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M18.4 5.6l-2.1 2.1M7.7 16.3l-2.1 2.1" fill="none" stroke-width="1.6"/></svg>
        </div>
      </div>

      <!-- profile -->
      <div class="profile">
        <div class="ptext">
          <div class="pname">{{ name }}</div>
          <div class="pstatus">{{ status }}</div>
        </div>
        <span class="pavatar" [style.background-image]="logo ? 'url(' + logo + ')' : null"></span>
      </div>
      </div><!-- /header-block -->

      <!-- search: magnifier left + QR scan right, like the real app -->
      <div class="search" [style.background]="searchBg || null">
        <svg class="s-ic" viewBox="0 0 20 20" aria-hidden="true">
          <circle cx="8.5" cy="8.5" r="5.5" fill="none" stroke="currentColor" stroke-width="1.8"></circle>
          <line x1="12.8" y1="12.8" x2="17" y2="17" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></line>
        </svg>
        <span class="s-l">Search</span>
        <svg class="s-scan" viewBox="0 0 20 20" aria-hidden="true">
          <rect x="1" y="1" width="6.5" height="6.5" rx="1.4" fill="none" stroke="currentColor" stroke-width="1.5"></rect>
          <rect x="12.5" y="1" width="6.5" height="6.5" rx="1.4" fill="none" stroke="currentColor" stroke-width="1.5"></rect>
          <rect x="1" y="12.5" width="6.5" height="6.5" rx="1.4" fill="none" stroke="currentColor" stroke-width="1.5"></rect>
          <rect x="3.2" y="3.2" width="2.1" height="2.1" fill="currentColor"></rect>
          <rect x="14.7" y="3.2" width="2.1" height="2.1" fill="currentColor"></rect>
          <rect x="3.2" y="14.7" width="2.1" height="2.1" fill="currentColor"></rect>
          <rect x="11.5" y="11.5" width="2.4" height="2.4" fill="currentColor"></rect>
          <rect x="16.6" y="11.5" width="2.4" height="2.4" fill="currentColor"></rect>
          <rect x="14" y="14" width="2.4" height="2.4" fill="currentColor"></rect>
          <rect x="11.5" y="16.6" width="2.4" height="2.4" fill="currentColor"></rect>
          <rect x="16.6" y="16.6" width="2.4" height="2.4" fill="currentColor"></rect>
        </svg>
      </div>

      <!-- Friend lists (order mirrors LINE's mockup: Favorites / Friends /
           Groups, each with a pink sub-line + count, BEFORE Services). Our own
           profile assets (i_20 person, i_21 group) stand in for the avatars. -->
      <div class="sec-head">Friend lists <span class="see">See more</span></div>

      <div class="list-row">
        <span class="badge badge--avatar">
          <app-line-profile kind="person" [product]="product"></app-line-profile>
        </span>
        <div class="row-text">
          <div class="row-title">Favorites</div>
          <div class="row-sub">Jihyun Kim, Seungjoo O, S…</div>
        </div>
        <span class="row-count">6</span>
        <span class="row-end">›</span>
      </div>

      <div class="list-row">
        <span class="badge badge--avatar">
          <app-line-profile kind="person" [product]="product"></app-line-profile>
        </span>
        <div class="row-text">
          <div class="row-title">Friends</div>
          <div class="row-sub">Ava kali, Brian Paak, Chloe…</div>
        </div>
        <span class="row-count">12</span>
        <span class="row-end">›</span>
      </div>

      <div class="list-row">
        <span class="badge badge--avatar">
          <app-line-profile kind="group" [product]="product"></app-line-profile>
        </span>
        <div class="row-text">
          <div class="row-title">Groups</div>
          <div class="row-sub">English Study group (4), W…</div>
        </div>
        <span class="row-count">5</span>
        <span class="row-end">›</span>
      </div>

      <!-- services (four, below the friend lists, like the mockup) -->
      <div class="sec-head">Services <span class="see">See more</span></div>
      <div class="services">
        <!-- The four service glyphs, redrawn from the owner's device screenshots
             (2026-08-14) after the first pass drew them from memory and got two
             of the four wrong: Themes was a narrow pen nib where LINE draws a
             wide flat BRUSH, and LINE Game was a fully-rounded capsule where
             LINE draws a soft-cornered rectangle. The shield's star was also
             drawn large enough to fill it, where LINE keeps it small with the
             shield reading as the shape. Shared markup, so this is every LINE
             theme's preview at once, not just Istanbul's. -->
        <div class="svc">
          <svg viewBox="0 0 30 30" class="svc-ic"><circle cx="15" cy="15" r="9" fill="none" stroke-width="1.7"/><circle cx="12.4" cy="12.8" r="1.05"/><circle cx="17.6" cy="12.8" r="1.05"/><path d="M12.8 17 q2.2 2.1 4.4 0" fill="none" stroke-width="1.7" stroke-linecap="round"/></svg>
          <span class="svc-l">Stickers</span>
        </div>
        <div class="svc">
          <svg viewBox="0 0 30 30" class="svc-ic"><path d="M14.3 3.8 L15.7 3.8 L15.7 9.9 L20.3 14.9 L9.7 14.9 L14.3 9.9 Z" fill="none" stroke-width="1.6" stroke-linejoin="round"/><rect x="9" y="14.9" width="12" height="5.3" rx="0.7" fill="none" stroke-width="1.6"/><path d="M9 17.5 h12" stroke-width="1.3"/></svg>
          <span class="svc-l">Themes</span>
        </div>
        <div class="svc">
          <svg viewBox="0 0 30 30" class="svc-ic"><path d="M15 4.4 l6.6 2.4 v5 c0 4.7-2.9 7.9-6.6 9.5 -3.7-1.6-6.6-4.8-6.6-9.5 V6.8 z" fill="none" stroke-width="1.7" stroke-linejoin="round"/><path d="M15.0 9.2L15.5 10.6L16.9 10.7L15.8 11.6L16.2 13.0L15.0 12.2L13.8 13.0L14.2 11.6L13.1 10.7L14.5 10.6Z"/></svg>
          <span class="svc-l">Official<br>Accounts</span>
        </div>
        <div class="svc">
          <svg viewBox="0 0 30 30" class="svc-ic"><rect x="4.6" y="10" width="20.8" height="11" rx="3.2" fill="none" stroke-width="1.7"/><path d="M10 13.4 v3.6 M8.2 15.2 h3.6" fill="none" stroke-width="1.7" stroke-linecap="round"/><circle cx="19.8" cy="14.2" r="1.15"/><circle cx="22.4" cy="17" r="1.15"/></svg>
          <span class="svc-l">LINE Game</span>
        </div>
      </div>

      <div class="spacer"></div>

      <!-- bottom tab bar with the live menu background behind it. Real LINE
           tab order (Home / Chats / Voom / TODAY / Wallet) with the SAME
           Phosphor masks as the uploaded tab-button assets: Home is ON
           (electric green, matching its ribbon), the rest are OFF (muted,
           15% smaller), a 1:1 preview of the real bottom bar. -->
      <div class="tabbar" [class.glass]="ios26"
           [style.--glass-bg]="glassBg" [style.--glass-pill]="glassPill" [style.--glass-on-text]="glassOnText">
        <app-line-menu-bg *ngIf="!ios26" class="tab-bg" [product]="product"></app-line-menu-bg>
        <!--
          The tab row renders the REAL asset component, one per slot.

          It used to hand-copy each theme's Home glyph here — sakura's blossom,
          tokyo's tower, everest's summit, aurora's orb, sequoia's redwood,
          autumn's maple, roraima's sun, miami's palm — every one a second copy
          of markup that also lives in line-menu-button. They drifted constantly
          and a new theme silently showed the generic Phosphor icon until someone
          remembered to add a ninth branch (owner 2026-08-13: "previewler neden
          assetleri yansıtmıyor artık"). Now the mockup cannot disagree with the
          export, because it IS the export, and a new theme needs no work here at
          all. `g` follows the iOS-26 toggle, so the glass preview shows the _g
          glyphs the phone will actually draw.
        -->
        <div class="tabs" [style.--tab-off]="tabOff || null">
          <div class="tab" *ngFor="let t of previewTabs" [class.on]="t.on"
               [style.--tab-on]="tabOn">
            <span class="t-glow">
              <app-line-menu-button class="t-btn" [product]="product" [name]="t.name"
                                    [on]="t.on" [g]="ios26"></app-line-menu-button>
            </span>
            <span>{{ t.label }}</span>
          </div>
        </div>
      </div>

      <div class="tab-fill" *ngIf="!ios26" [style.background]="tabFill"></div>
    </div>

    <img class="frame" [src]="frameSrc" alt="" aria-hidden="true">
  </div>
</div>
